export const opened = () => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.open_menu = true;
};

export const closed = () => {
  const html = document.querySelector('html');

  if (typeof html.dataset.flocktory !== 'string') {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.open_menu = false;
  }
};

export const getScrollbarSize = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.msOverflowStyle = 'scrollbar';

  document.body.appendChild(outer);

  const widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = 'scroll';

  // add inner div
  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);

  return widthNoScroll - widthWithScroll;
};

export const blockScroll = () => {
  document.body.style.width = `calc(100% - ${getScrollbarSize()}px)`;
};

export const unlockScroll = () => {
  document.body.style.width = '';
};
